import {
  formatDisplayDate,
  getRangeForPreset,
  WalletDatePreset,
  WALLET_DATE_PRESET_OPTIONS,
} from '../wallet/walletDateRange'

export type PaymentDatePreset = WalletDatePreset

export type PaymentFilterState = {
  preset: PaymentDatePreset
  date_from: string
  date_to: string
  label: string
  all_time?: boolean
  transaction_type: string
}

export const PAYMENT_DATE_PRESET_OPTIONS = WALLET_DATE_PRESET_OPTIONS

/** Default filter options; PaymentFilter loads full list from API when opened. */
export const PAYMENT_TYPE_OPTIONS = [
  {value: '', label: 'All transaction types'},
  {value: 'driver', label: 'Driver Subscription'},
  {value: 'passenger', label: 'Credit Purchase'},
  {value: 'other', label: 'Auto Recharge'},
]

/** Default: this month (matches previous payment list behaviour). */
export const getDefaultPaymentFilter = (): PaymentFilterState => {
  const range = getRangeForPreset('thisMonth')
  return {...range, transaction_type: ''}
}

export const buildPaymentFilterSummary = (
  filter: PaymentFilterState,
  search: string,
  totalRecords?: number
): string => {
  const rangeText = filter.all_time
    ? 'all dates'
    : filter.date_from === filter.date_to
      ? formatDisplayDate(filter.date_from)
      : `${formatDisplayDate(filter.date_from)} – ${formatDisplayDate(filter.date_to)}`

  const typeLabel = filter.transaction_type
    ? PAYMENT_TYPE_OPTIONS.find((o) => o.value === filter.transaction_type)?.label ??
      filter.transaction_type.replace(/_/g, ' ')
    : 'all types'

  const parts = [filter.label, `(${rangeText})`, typeLabel]
  if (search.trim()) parts.push(`search: "${search.trim()}"`)
  if (totalRecords !== undefined) {
    parts.push(`${totalRecords} payment${totalRecords === 1 ? '' : 's'}`)
  }
  return parts.join(' · ')
}
